customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.sectionId = this.dataset.sectionId),
          (this.form = this.querySelector("form")),
          this.form && ((this.form.querySelector("[name=id]") || {}).disabled = !1),
          this.form && this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog");
      }
      onSubmitHandler(evt) {
        if (
          (evt.preventDefault(),
          this.submitButton.getAttribute("aria-disabled") === "true")
        )
          return;
        this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading");
        const config = fetchConfig("javascript"),
          formData = new FormData(this.form),
          body = { items: this.getProductsData(formData) };
        this.cart &&
          ((body.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id)),
          (body.sections_url = window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
          (config.body = JSON.stringify(body)),
          fetch(`${(typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js'}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  soldOutMessage.classList.remove("hidden"),
                  (this.error = !0);
                return;
              } else if (!this.cart) {
                const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) 
                  ? routes.cart_url 
                  : ((typeof window !== 'undefined' && window.routes && window.routes.cart_url) 
                    ? window.routes.cart_url 
                    : '/cart')
                window.location = cartUrl;
                return;
              }
              this.error = !1;
              const quickAddModal = this.closest("quick-add-modal");
              quickAddModal
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: !0 }
                  ),
                  quickAddModal.hide(!0))
                : this.cart.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty");
              this.error ||
                this.submitButton.removeAttribute("aria-disabled");
              const spinner = this.querySelector(".loading-overlay__spinner");
              if (spinner) {
                spinner.classList.add("hidden");
              }
            });
      }
      getProductsData(formData) {
        const mainProduct = {},
          products = this.getAdditionalItems(
            `#UpsellProductList-${this.sectionId}`
          );
        for (const entry of formData)
          if (entry[0] == "id") mainProduct.id = entry[1];
          else if (entry[0].includes("quantity"))
            mainProduct.quantity = parseInt(entry[1]);
          else if (entry[0].includes("properties")) {
            const first = entry[0].replace("properties[", "").replace("]", ""),
              last = entry[1],
              properties = { [first]: last };
            mainProduct.properties = properties;
          }
          if (window.promoName && products.length > 0) {
            for (let i = 0; i < products.length; i++) {
              products[i].properties = products[i].properties || {};
              products[i].properties._currPromoName = window.promoName;
            }
          }
        return [...products, mainProduct];
      }
      getAdditionalItems(id) {
        const products = document.querySelectorAll(`${id} bundle-item`),
          data = [];
        return (
          products.length > 0 &&
            products.forEach((product) => {
              const select = product.querySelector("select[name='quantity']"),
                variant = product.dataset.currentVariant,
                estimatedShippingText = product.dataset.estimatedShippingText,
                estimatedShippingDate = product.dataset.estimatedShippingDate,
                quantity = select ? parseInt(select.value) : 1;
              // Check if this is an add-on by checking if the select is inside addons-quantity
              const isAddon = select && select.closest("addons-quantity") !== null;
              const properties = {};
              
              // Add estimated shipping property if available
              if (estimatedShippingText && estimatedShippingDate) {
                properties[estimatedShippingText] = estimatedShippingDate;
              }
              
              // Add add-ons tracking property if this is an add-on
              if (isAddon && quantity > 0) {
                properties._added_from_location = "add-ons";
              }
              
              if (quantity > 0) {
                // Ensure variant ID is a string (Shopify API requirement)
                const variantIdStr = String(variant);
                const item = { 
                  quantity, 
                  id: variantIdStr 
                };
                
                // Only add properties object if there are properties to add
                if (Object.keys(properties).length > 0) {
                  item.properties = properties;
                }
                
                data.push(item);
              }
            }),
          data.reverse()
        );
      }
      handleErrorMessage(errorMessage = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage),
            errorMessage && (this.errorMessage.textContent = errorMessage));
      }
    }
  );
